import React from 'react';
import {
  CardDivider,
} from 'components/card/Card2';
import SearchBar from './components/SearchBar/SearchBar';
import Parkings from './components/Parkings/Parkings';
import styles from './style.cssmodule.css';
import { ParkingsProvider } from './contexts/ParkingsContext';

function ParkingsContainer() {
  return (
    <ParkingsProvider>
      <div className={styles.background}>
        <div className={styles.container}>
          <SearchBar />
          <CardDivider />
          <Parkings />
        </div>
      </div>
    </ParkingsProvider>
  );
}

module.exports = ParkingsContainer;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/ParkingsContainer.jsx